export default UnderConstruction = () => {
	alert(
		"This page is under development 🚧 and will be delivered with all other Sprint 2 & Sprint 3 pages on 3/20/23. On that date, this message will be removed and the pages may be QA'd."
	);
};
